var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.46045 20.8466H20.9282C21.7339 20.8466 22.3886 20.1918 22.3886 19.3862V16.0904H15.4004C14.8771 16.0904 14.3659 15.9882 13.8864 15.7837C13.4239 15.589 13.0077 15.3067 12.6523 14.9513C12.297 14.5959 12.0146 14.1797 11.8199 13.7172C11.6179 13.2377 11.5132 12.7265 11.5132 12.2032V11.7918C11.5132 11.2685 11.6154 10.7574 11.8199 10.2779C12.0146 9.81538 12.297 9.39915 12.6523 9.04377C13.0077 8.6884 13.4239 8.40604 13.8864 8.21132C14.3659 8.00929 14.8771 7.90462 15.4004 7.90462H22.3886V4.60888C22.3886 3.8032 21.7339 3.14844 20.9282 3.14844H1.46045C0.654767 3.14844 0 3.8032 0 4.60888V19.3862C0 20.1918 0.654767 20.8466 1.46045 20.8466Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 10.4625C24 9.85644 23.5108 9.36719 22.9047 9.36719H22.3886H15.4004C14.0592 9.36719 12.9736 10.4528 12.9736 11.794V12.2053C12.9736 13.5465 14.0592 14.6321 15.4004 14.6321H22.3886H22.9047C23.5108 14.6321 24 14.1428 24 13.5367V10.4625ZM15.7972 13.2885C15.084 13.2885 14.5071 12.7116 14.5071 11.9984C14.5071 11.2852 15.084 10.7084 15.7972 10.7084C16.5103 10.7084 17.0872 11.2852 17.0872 11.9984C17.0872 12.7116 16.5103 13.2885 15.7972 13.2885Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.acde5d7bdb0dd91f888a019e76900092.svg";
export { ForwardRef as ReactComponent };